import { UploadIcon } from '@mm/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { colors, PropTypeFromComponent } from '@mm/utils';
import classNames from 'classnames';
import React, { MouseEvent } from 'react';
import { useSelector } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../common/buttons/PrimaryButton/PrimaryButton';
import { PrimaryToolTip } from '../../../common/components/PrimaryToolTip/PrimaryToolTip';
import { usePhoneNumber } from '../../../common/hooks/use-phone-number';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { useImportContactsPermission } from '../../../common/hooks/use-import-contacts-permission';

type Props = {
  className?: string;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => any;
  disabled?: boolean;
  isSecondary?: boolean;
  color?: PropTypeFromComponent<typeof PrimaryButton, 'color'>;
  text?: string;
  asDiv?: boolean;
  tooltip?: string;
};

const Button = (props: Props) => (
  <PrimaryButton
    {...props}
    className={classNames(props.className)}
    disabled={props.disabled}
    onClick={props.onClick}
    color={
      props.color ||
      (props.isSecondary ? ButtonColor.secondaryBlue : ButtonColor.transparent)
    }
    leftIcon={
      <UploadIcon color={props.isSecondary ? colors.accentBlue : colors.body} />
    }
  >
    {props.text}
  </PrimaryButton>
);

export const ImportContactsButton = ({
  onClick,
  asDiv,
  text,
  tooltip,
  ...rest
}: Props) => {
  const { isAllowed } = useImportContactsPermission();
  const modalActions = useModalActions();

  const onImportClick = () => modalActions.openImportContactListModal();

  if (!isAllowed) {
    return (
      <PrimaryToolTip
        anchorElement={<Button disabled={true} {...rest} />}
        useHover={true}
      >
        Connect an Email Account or activate a phone number first
      </PrimaryToolTip>
    );
  }

  return asDiv ? (
    <div onClick={onImportClick} {...rest}>
      <UploadIcon />
      {text}
    </div>
  ) : (
    <Button onClick={onImportClick} text={text} {...rest} />
  );
};
